var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('boat-form',{model:{value:(_vm.boat),callback:function ($$v) {_vm.boat=$$v},expression:"boat"}})}
var staticRenderFns = []

export { render, staticRenderFns }